import { useEffect } from 'react';
import { useAnalytics } from '@msrceng/analytics';
import { useFilterData } from '../SearchFilter/filterContext';

/**
 * Hook to log app insights events for data download requests.
 */
export const useDownloadRecordRequestEffect = ({
  isDownloading,
  downloadComplete,
  rowCount,
  fileType,
  tableName,
}: {
  /** Indicates download is in progress */
  isDownloading: boolean;
  /** indicates download just finished */
  downloadComplete: boolean;
  /** total number of rows in the dataset */
  rowCount?: number;
  /** file type of the download */
  fileType: string;
  /** name of the table being downloaded */
  tableName: string;
}) => {
  const { filterStateList } = useFilterData();

  const { appInsights } = useAnalytics();
  // Log download starts
  useEffect(() => {
    if (isDownloading) {
      appInsights?.trackEvent?.(
        { name: 'Download data: start' },
        {
          filterStateList,
          rowCount,
          fileType,
          tableName,
        }
      );
    }
    // we only want to log on useful changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDownloading, appInsights]);

  // Log download completes
  useEffect(() => {
    if (downloadComplete) {
      appInsights?.trackEvent?.(
        { name: 'Download data: complete' },
        {
          filterStateList,
          rowCount,
          fileType,
          tableName,
        }
      );
    }
    // we only want to log on useful changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadComplete, appInsights]);
};
